var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { width: "100%", margin: "0px auto", marginTop: "25px" } },
    [
      _c(
        "w-col",
        { attrs: { sm: "12", md: "8" } },
        [
          _vm.mandates.length == 0
            ? _c(
                "w-card",
                { staticClass: "mb" },
                [
                  _c("w-card-content", [
                    _c("h2", [_vm._v(_vm._s(_vm.$ct("title")))]),
                    _c("p", {
                      directives: [
                        {
                          name: "safe-html",
                          rawName: "v-safe-html",
                          value: _vm.$ct("no-payment-method-info"),
                          expression: "$ct('no-payment-method-info')",
                        },
                      ],
                      staticClass: "info",
                    }),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c("app-payment-methods", {
            attrs: { plan: _vm.plan, "limit-methods": true },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { sm: "12", md: "4" } },
        [
          _vm.hasBillingAddress && _vm.price
            ? _c("app-upgrade-card", {
                attrs: {
                  plan: _vm.plan,
                  mandate: _vm.mandate,
                  price: _vm.price,
                },
              })
            : _c("app-billing-address"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }